$((function(){
  if($(".trade-rates-index").length) {
    let $homepage = $(".trade-rates-index");
    let $tradeRatePopup = $("#tradeRatePopup");

    $homepage.on("click", ".create-trade-rate", function(){
      resetPopup();
    });

    $homepage.on("click", ".trade-rate-row .code", function(){
      let $row = $(this).parents(".trade-rate-row");
      resetPopup();
      $tradeRatePopup.find(".modal-title").html("Update Rate");
      $tradeRatePopup.find(".btn-save").html("Update");
      $tradeRatePopup.find(".trade_rate_id").val($row.attr("value"));
      $row.find("td").each(function(){
        let $this = $(this);
        if($tradeRatePopup.find("input."+$this.attr("name")).length) {
          $tradeRatePopup.find("input."+$this.attr("name")).val($this.attr("value"));
        }
        else if($tradeRatePopup.find("select."+$this.attr("name")).length) {
          $tradeRatePopup.find("select."+$this.attr("name") +" option[value='"+$this.attr("value")+"']").prop('selected', true);
        }
        else if($tradeRatePopup.find("textarea."+$this.attr("name")).length) {
          $tradeRatePopup.find("textarea."+$this.attr("name")).val($this.attr("value"));
        }
      });
    });

    $tradeRatePopup.on("click", ".btn-save", function(){
      $tradeRatePopup.find(".message-row").find(".error, .message").html("").addClass("hide");
      if(validateEmptyFields($tradeRatePopup)) {
        $tradeRatePopup.find(".message-row .error").html("Fields must not be empty");
        $tradeRatePopup.find(".message-row .error").removeClass("hide");
      }
      else {
        $tradeRatePopup.find(".main-buttons-row").addClass("hide");
        $tradeRatePopup.find(".loading-row .loading-div").removeClass("hide");

        $.ajax({
          type: "POST",
          url:  "/admins/trade_rates",
          data: new FormData($tradeRatePopup.find("form")[0]),
          contentType: false,
          cache: false,
          processData: false,
          success: function (result){
            if(result.status == 200) {
              $tradeRatePopup.find(".message-row .message").html(result.message).removeClass("hide");
              $tradeRatePopup.find(".btn-save, .btn-cancel").addClass("hide");
              setTimeout(function(){
                window.location.reload();
              }, 2000);
            }
            else {
              $tradeRatePopup.find(".btn-save").removeClass("hide");
              $tradeRatePopup.find(".message-row .error").html(result.error).removeClass("hide");
            }
            $tradeRatePopup.find(".main-buttons-row").removeClass("hide");
            $tradeRatePopup.find(".whirl.no-overlay").addClass("hide");
          }
        });
      }
    });

    let resetPopup = function(){
      $tradeRatePopup.find(".modal-title").html("Create Rate");
      $tradeRatePopup.find(".btn-save").html("Create").removeClass("hide");
      $tradeRatePopup.find(".btn-cancel").html("Cancel");
      $tradeRatePopup.find(".message-row").find(".error, .message").html("").addClass("hide");
      $tradeRatePopup.find(".trade_rate_id").val(null);
      $tradeRatePopup.find("input, textarea").val("");
      $tradeRatePopup.find("select").prop("selectedIndex", 0);
    }

    let validateEmptyFields = function(parent) {
      let isEmpty = false;
      parent.find("input:not(.not-required)").each(function(){
        let $this = $(this);
        if($this.val().trim() == "") {
          $this.addClass("error");
          isEmpty = true;
        }
      });
      return isEmpty;
    }
  }
}));